import "../../../styles/login.scss";

import Icon, {iconTypes} from "./Icon.jsx";

import {Localization} from "../util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "./ResponsiveColumn.jsx";
import ResponsiveRows from "./ResponsiveRows.jsx";
import TextField from "./TextField.jsx";

import bg from "../../../assets/images/bg.png";
import logo from "../../../assets/images/engrospartner_logo.png";
import {withRouter} from "react-router-dom";

class LoginPage extends React.PureComponent {
    constructor(props){
        super(props);
        this.state = {
            loginName: "",
            password: "",
            capsLock: false,
        };

        this.onChange = this.onChange.bind(this);
        this.logIn = this.logIn.bind(this);
        this.onClickResetPassword = this.onClickResetPassword.bind(this);
        this.setCapsLockActive = this.setCapsLockActive.bind(this);

        this.validateUserName = this.validateUserName.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.props.setCurrentLanguage("no");
    }

    onChange(change) {
        this.setState(change);
    }

    logIn(event) {
        const {
            logIn,
            history
        } = this.props;
        const {loginName, password} = this.state;
        event.stopPropagation();
        event.preventDefault();
        logIn(history, loginName, password);
    }

    onClickResetPassword() {
        this.props.history.replace("/login/forgotPassword");
    }

    setCapsLockActive(status) {
        this.setState({
            capsLock: status,
        });
    }

    validateUserName(loginName) {
        return this.props.validateCusNo(loginName) || this.props.validateEmail(loginName);
    }

    render(){
        const {
            loggingIn,
            localization,
            validatePassword,
        } = this.props;

        //const canSubmit = (!loggingIn && this.validateUserName(this.state.loginName) && validatePassword(this.state.password)) || (this.state.loginName.length===0 && this.state.password===0);

        return (
            <React.Fragment>
                <div className="login-background">
                    <img src={bg} className="login-background-img"/>
                </div>
                <div className="login-engrospartner-logo">
                    <img src={logo} />
                </div>
                <div className="login-wrapper card-default">
                    <ResponsiveRows>
                        <ResponsiveColumn xs={12}>
                            <div className="header-wrapper">
                                <Icon type={iconTypes.account} className="header-icon"/>
                                <div className="header-text">
                                    {localization.text("login","signInToYourAccount")}
                                </div>
                            </div>
                        </ResponsiveColumn>
                    </ResponsiveRows>
                    <div className="hr"/>
                    <form onSubmit={this.logIn}>
                        <ResponsiveRows>
                            <ResponsiveColumn xs={12}>
                                <TextField onEdit={this.onChange} onChange={this.onChange} iconType={iconTypes.message} source={this.state} property={"loginName"} placeholder={localization.text("login","userName")} validation={this.validateUserName} disabled={loggingIn} capsLockStatusCallback={this.setCapsLockActive} autoFocus={true} />
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={12}>
                                <TextField onEdit={this.onChange} onChange={this.onChange} iconType={iconTypes.key} type="password" source={this.state} property={"password"} placeholder={localization.text("login","password")} validation={validatePassword} disabled={loggingIn} capsLockStatusCallback={this.setCapsLockActive}/>
                            </ResponsiveColumn>
                            {this.state.capsLock && (
                                <ResponsiveColumn xs={12}>
                                    <div className="caps-lock-warning">
                                        <Icon type={iconTypes.warning} />
                                        {localization.text("login","capsLockIsActive")}
                                    </div>
                                </ResponsiveColumn>
                            )}
                            <ResponsiveColumn xs={12}>
                                <div className="bottom-wrapper">
                                    <div className="bottom-text" onClick={this.onClickResetPassword}>
                                        {localization.text("login","needANewPassword")}
                                    </div>
                                    <button className={"btn primary"}>
                                        {localization.text("login","signIn")}
                                    </button>
                                </div>
                            </ResponsiveColumn>
                        </ResponsiveRows>
                    </form>
                </div>
                <div className="login-copyright-notice" >
                    Kolly Tool 2019 @ All rights reserved.
                </div>
            </React.Fragment>
        );
    }
}

LoginPage.propTypes = {
    authentication: PropTypes.object,
    clientOutOfDate: PropTypes.bool,
    changes: PropTypes.array,
    currentLanguage: PropTypes.string,
    deviceType: PropTypes.string.isRequired,
    downloadingLocalization: PropTypes.bool,
    history: PropTypes.object,
    localization: Localization.propTypes.isRequired,
    logIn: PropTypes.func.isRequired,
    loggingIn: PropTypes.bool,
    reasonForFailedLogin: PropTypes.string,
    setCurrentLanguage: PropTypes.func.isRequired,
    token: PropTypes.string,
    validateCusNo: PropTypes.func.isRequired,
    validateEmail: PropTypes.func.isRequired,
    validatePassword: PropTypes.func.isRequired,
};

export default withRouter(LoginPage);